import axios from "axios";

export const state = {
    reportpharmacybymonths: [],
};

export const getters = {
    reportpharmacybymonths: state => state.reportpharmacybymonths,
};

export const mutations = {
    setReportPharmacybyMonths(reportpharmacybymonths, newValue) { state.reportpharmacybymonths = newValue},
};

export const actions = {
    fetchReportPharmacybyMonths({ commit }) {
        axios.get('/reportpharmacybymonths').then(res => {
            commit('setReportPharmacybyMonths', res.data.payments)
        })
    },
    filterReportPharmacybyMonths({commit}, {month,year}) { 
        let formData = new FormData();
        formData.append("month", month);
        formData.append("year", year);
        let url = "/filterreportpharmacybymonths";
        axios.post(url, formData).then((response) => {
            commit('setReportPharmacybyMonths', response.data.payments)
        })
    },
};
